import { Component, Input, OnInit, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ModalController, AlertController, ActionSheetController } from '@ionic/angular';
import { CameraSource, Camera } from '@capacitor/camera';
import { JavapiService } from '../../services/javapi.service';
import { Modelogeneraldatos } from '../../models/modelogeneraldatos';
import { MetodosgenService } from '../../services/metodosgen.service';
import { Metodosui } from '../../services/metodosui';
import { firstValueFrom } from 'rxjs';
import { AdminCrudPage } from '../../pages/ajustes/admin-crud/admin-crud.page';
import { VerimagenComponent } from '../verimagen/verimagen.component';
import { DocumentScanner, ScannerMode } from '@capgo/capacitor-document-scanner';
import { Filesystem } from '@capacitor/filesystem';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-gastos-form-modal',
  templateUrl: './gastos-form-modal.component.html',
  styleUrls: ['./gastos-form-modal.component.scss'],
  standalone: false
})
export class GastosFormModalComponent implements OnInit {

  @Input() trabajoId!: number;
  @Input() gasto: any; // If null, it's a new gasto
  @Input() uniqueLugares: string[] = [];
  @ViewChild('fileInput') fileInput!: ElementRef;

  gastoActual: any;
  saving = false;
  loading = false;
  loadingAI = false;
  aiAttemptStatus = 'Llenar formulario con IA';
  
  archivosPreview: string[] = [];
  archivosNuevosBase64: string[] = [];
  archivoName: string = '';
  isPdf = false;
  archivoEliminado = false;

  showLugarDropdown = false;
  showTipoDropdown = false;
  filteredLugares: any[] = []; // Changed to any[] to support objects {id, nombre}
  filteredTipos: any[] = [];
  selectedCategorias: string[] = [];
  inputTipo: string = '';
  comerciosList: any[] = [];
  categoriasList: any[] = [];
  

  constructor(
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private javapiService: JavapiService,
    private metodosUi: Metodosui,
    private metodosGenService: MetodosgenService,
    private actionSheetCtrl: ActionSheetController,
    private el: ElementRef
  ) { }

  ngOnInit() {
    if (this.gasto) {
      this.gastoActual = { ...this.gasto };
      if (this.gastoActual.tipo) {
        this.selectedCategorias = this.gastoActual.tipo
          .split(',')
          .map((t: string) => t.trim())
          .filter((t: string) => t.length > 0);
      }
      this.loadExistingAttachment();
    } else {
      this.gastoActual = {
        id: 0,
        fecha: this.getTodayLocalString(),
        lugar: '',
        monto: null,
        descripcion: '',
        tipo: 'Compra',
        archivoBase64: null,
        archivos: ''
      };
      this.selectedCategorias = ['Compra'];
    }
    this.updateTipoString();
    this.loadComercios();
    this.loadCategorias();
  }

  async loadComercios() {
    try {
      const res: any = await firstValueFrom(this.javapiService.getJsonParam('fe_lista_comercios'));
      if (res && res.pa_json) {
        this.comerciosList = typeof res.pa_json === 'string' ? JSON.parse(res.pa_json) : res.pa_json;
      } else if (res && res.dt3) {
        this.comerciosList = typeof res.dt3 === 'string' ? JSON.parse(res.dt3) : res.dt3;
      }
    } catch (e) {
      console.error('Error loading comercios', e);
    }
  }

  async loadCategorias() {
    try {
      const res: any = await firstValueFrom(this.javapiService.getJsonParam('fe_lista_categorias_gastos'));
      if (res && res.pa_json) {
        this.categoriasList = typeof res.pa_json === 'string' ? JSON.parse(res.pa_json) : res.pa_json;
      } else if (res && res.dt3) {
        this.categoriasList = typeof res.dt3 === 'string' ? JSON.parse(res.dt3) : res.dt3;
      }
      this.filteredTipos = [...this.categoriasList];
    } catch (e) {
      console.error('Error loading categorias', e);
    }
  }

  loadingAttachment = false;

  loadExistingAttachment() {
    if (this.gastoActual.archivos && this.gastoActual.archivos.length > 0) {
      const archivos = this.gastoActual.archivos.split(',');
      const mainArchivo = archivos[0];
      if (mainArchivo.endsWith('.pdf')) {
        this.isPdf = true;
        this.archivoName = mainArchivo;
      } else {
        const imageFiles = archivos.filter((arch: string) => !arch.endsWith('.pdf') && arch.trim() !== '');
        if (imageFiles.length > 0) {
          this.loadingAttachment = true;
          let loadedCount = 0;
          for (const arch of imageFiles) {
            this.javapiService.getImage(arch.trim(), 'path_img_trabajos_gastos').subscribe({
              next: (base64) => {
                if (base64) {
                  this.archivosPreview.push('data:image/jpeg;base64,' + base64);
                }
                loadedCount++;
                if (loadedCount === imageFiles.length) {
                  this.loadingAttachment = false;
                }
              },
              error: (err) => {
                console.error(err);
                loadedCount++;
                if (loadedCount === imageFiles.length) {
                  this.loadingAttachment = false;
                }
              }
            });
          }
        }
      }
    }
  }


  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.el.nativeElement.contains(event.target)) {
      this.showLugarDropdown = false;
      this.showTipoDropdown = false;
    } else {
      const target = event.target as HTMLElement;
      if (!target.closest('.autocomplete-wrapper')) {
        this.showLugarDropdown = false;
        this.showTipoDropdown = false;
      }
    }
  }

  filterLugares(ev: any) {
    const val = ev.target.value?.toLowerCase() || '';
    if (val.length > 0) {
      // Filter from global comerciosList with null check
      this.filteredLugares = this.comerciosList.filter(c => (c.nombre || '').toLowerCase().includes(val));
      this.showLugarDropdown = true;
    } else {
      this.filteredLugares = [];
      this.showLugarDropdown = false;
    }
  }

  async createComercio() {
    this.showLugarDropdown = false;
    const modal = await this.modalCtrl.create({
      component: AdminCrudPage,
      componentProps: { 
        entity: 'COMERCIO', 
        autoOpenAdd: true,
        initialData: { dt2: this.gastoActual.lugar } 
      }
    });
    await modal.present();
    await modal.onDidDismiss();
    // Refresh list to see the new commerce
    await this.loadComercios();
  }

  selectLugar(loc: any) {
    this.gastoActual.lugar = loc.nombre || loc;
    this.showLugarDropdown = false;
  }

  get showCreateLugarOption(): boolean {
    if (!this.gastoActual.lugar || this.gastoActual.lugar.trim() === '') return false;
    const val = this.gastoActual.lugar.toLowerCase().trim();
    return !this.comerciosList.some(c => (c.nombre || '').toLowerCase().trim() === val);
  }

  filterTipos(ev: any) {
    const val = ev.target.value?.toLowerCase() || '';
    this.inputTipo = ev.target.value || '';
    if (val.length > 0) {
      this.filteredTipos = this.categoriasList.filter(t => (t.nombre || t).toLowerCase().includes(val));
    } else {
      this.filteredTipos = [...this.categoriasList];
    }
    this.showTipoDropdown = true;
  }

  get showCreateCategoriaOption(): boolean {
    if (!this.inputTipo || this.inputTipo.trim() === '') return false;
    const val = this.inputTipo.toLowerCase().trim();
    return !this.categoriasList.some(c => (c.nombre || '').toLowerCase().trim() === val);
  }

  async createCategoria() {
    this.showTipoDropdown = false;
    const catName = this.inputTipo.trim();
    const modal = await this.modalCtrl.create({
      component: AdminCrudPage,
      componentProps: { 
        entity: 'GASTO_CATEGORIA', 
        autoOpenAdd: true,
        initialData: { dt2: catName } 
      }
    });
    await modal.present();
    await modal.onDidDismiss();
    // Refresh list to see the new category
    await this.loadCategorias();
    if (catName && !this.selectedCategorias.includes(catName)) {
      this.selectedCategorias.push(catName);
      this.updateTipoString();
    }
    this.inputTipo = '';
  }

  showAllTipos() {
    this.filteredTipos = [...this.categoriasList];
    this.showTipoDropdown = this.categoriasList.length > 0;
  }

  toggleTipoDropdown(event: Event) {
    event.stopPropagation();
    this.showTipoDropdown = !this.showTipoDropdown;
    if (this.showTipoDropdown) {
      this.filteredTipos = [...this.categoriasList];
    }
  }

  showAllLugares() {
    this.filteredLugares = [...this.comerciosList];
    this.showLugarDropdown = this.comerciosList.length > 0;
  }

  toggleLugarDropdown(event: Event) {
    event.stopPropagation();
    this.showLugarDropdown = !this.showLugarDropdown;
    if (this.showLugarDropdown) {
      this.filteredLugares = [...this.comerciosList];
    }
  }

  selectTipo(tipo: any) {
    const nombre = (tipo.nombre || tipo).trim();
    if (nombre) {
      if (this.selectedCategorias.includes(nombre)) {
        this.selectedCategorias = this.selectedCategorias.filter(c => c !== nombre);
      } else {
        this.selectedCategorias.push(nombre);
      }
      this.updateTipoString();
    }
    this.inputTipo = '';
    this.showTipoDropdown = false;
  }

  removeCategoria(cat: string, event?: Event) {
    if (event) event.stopPropagation();
    this.selectedCategorias = this.selectedCategorias.filter(c => c !== cat);
    this.updateTipoString();
  }

  isCategoriaSelected(cat: string): boolean {
    if (!cat) return false;
    return this.selectedCategorias.includes(cat.trim());
  }

  updateTipoString() {
    this.gastoActual.tipo = this.selectedCategorias.join(', ');
  }

  clearLugar() { this.gastoActual.lugar = ''; this.showLugarDropdown = false; }
  clearTipo() { this.inputTipo = ''; this.showTipoDropdown = true; this.filteredTipos = [...this.categoriasList]; }

  changePhoto(event: Event) {
    event.stopPropagation();
    this.takePhoto();
  }

  async viewImage(previewUrl: string, startInCrop = false) {
    const modal = await this.modalCtrl.create({
      component: VerimagenComponent,
      componentProps: {
        image: previewUrl,
        title: 'Vista Previa de Comprobante',
        enableCrop: true,
        startInCropMode: startInCrop
      },
      cssClass: 'ver-imagen-modal'
    });
    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data && data.croppedBase64) {
      // Reemplazamos completamente por la imagen recortada para evitar adjuntos duplicados
      const cropped = data.croppedBase64;
      this.archivosPreview = [cropped];
      this.archivosNuevosBase64 = [cropped];
      this.isPdf = false;
      this.archivoEliminado = false;
    }
  }

  async takePhoto() {
    const actionSheet = await this.actionSheetCtrl.create({
      header: 'Seleccionar Origen',
      cssClass: 'custom-action-sheet',
      buttons: [
        {
          text: 'Cámara',
          icon: 'camera',
          handler: () => this.executeCapture(CameraSource.Camera)
        },
        {
          text: 'Galería',
          icon: 'image',
          handler: () => this.executeCapture(CameraSource.Photos)
        },
        { text: 'Cancelar', role: 'cancel', icon: 'close' }
      ]
    });
    await actionSheet.present();
  }

  async executeCapture(source: CameraSource) {
    try {
      if (source === CameraSource.Photos) {
        const isEditing = this.gastoActual && this.gastoActual.id > 0;
        const result = await Camera.pickImages({
          quality: 90,
          limit: isEditing ? 1 : 10
        });
        
        if (result.photos && result.photos.length > 0) {
          if (!isEditing && result.photos.length > 1) {
            const confirm = await this.metodosUi.showConfirmation(
              'Guardar Imágenes',
              'Se guardarán las imágenes y se cerrará el modal. Posteriormente deberá llenar los datos de las facturas.',
              'Aceptar'
            );
            if (!confirm) {
              return; // Cancel completely, keeping current state intact
            }

            await this.metodosUi.showLoading('Procesando imágenes...');
            const loadedPhotos: string[] = [];
            for (const photo of result.photos) {
              if (photo.webPath) {
                const response = await fetch(photo.webPath);
                const blob = await response.blob();
                const base64 = await this.convertBlobToBase64(blob) as string;
                loadedPhotos.push(base64);
              }
            }
            await this.metodosUi.hideLoading();

            if (loadedPhotos.length > 0) {
              await this.saveMultipleImagesDirectly(loadedPhotos);
            }
          } else {
            // Single photo flow
            const photo = result.photos[0];
            if (photo.webPath) {
              const response = await fetch(photo.webPath);
              const blob = await response.blob();
              const base64 = await this.convertBlobToBase64(blob) as string;
              this.archivosNuevosBase64 = [base64];
              this.archivosPreview = [base64];
              this.isPdf = false;
              this.archivoName = 'Foto_Gasto.jpg';
              this.archivoEliminado = false;
            }
          }
        }
      } else {
        if (Capacitor.isNativePlatform()) {
          const result = await DocumentScanner.scanDocument({
            letUserAdjustCrop: true,
            maxNumDocuments: this.gastoActual && this.gastoActual.id > 0 ? 1 : 10,
            scannerMode: ScannerMode.BaseWithFilter
          });

          if (result.scannedImages && result.scannedImages.length > 0) {
            const isEditing = this.gastoActual && this.gastoActual.id > 0;
            if (!isEditing && result.scannedImages.length > 1) {
              const confirm = await this.metodosUi.showConfirmation(
                'Guardar Imágenes',
                'Se guardarán las imágenes escaneadas y se cerrará el modal. Posteriormente deberá llenar los datos de las facturas.',
                'Aceptar'
              );
              if (!confirm) {
                return;
              }

              await this.metodosUi.showLoading('Procesando imágenes escaneadas...');
              const loadedPhotos: string[] = [];
              for (const imgUri of result.scannedImages) {
                const base64 = await this.readScannedImageBase64(imgUri);
                if (base64) loadedPhotos.push(base64);
              }
              await this.metodosUi.hideLoading();

              if (loadedPhotos.length > 0) {
                await this.saveMultipleImagesDirectly(loadedPhotos);
              }
            } else {
              await this.metodosUi.showLoading('Procesando escaneo...');
              const base64 = await this.readScannedImageBase64(result.scannedImages[0]);
              await this.metodosUi.hideLoading();
              if (base64) {
                this.archivosNuevosBase64 = [base64];
                this.archivosPreview = [base64];
                this.isPdf = false;
                this.archivoName = 'Scan_Gasto.jpg';
                this.archivoEliminado = false;
              }
            }
          }
        } else {
          const image = await this.metodosUi.takePicture(source);
          if (image && image.base64String) {
            const base64 = `data:image/jpeg;base64,${image.base64String}`;
            this.archivosNuevosBase64 = [base64];
            this.archivosPreview = [base64];
            this.isPdf = false;
            this.archivoName = 'Foto_Gasto.jpg';
            this.archivoEliminado = false;
          }
        }
      }
    } catch (error) {
      console.error('Error in executeCapture', error);
    }
  }

  async readScannedImageBase64(imgUri: string): Promise<string> {
    try {
      let filePath = imgUri;
      if (filePath.startsWith('file://')) {
        filePath = filePath.replace('file://', '');
      }
      const fileResult = await Filesystem.readFile({
        path: filePath
      });
      const rawBase64 = typeof fileResult.data === 'string' ? fileResult.data : '';
      return rawBase64.startsWith('data:') ? rawBase64 : `data:image/jpeg;base64,${rawBase64}`;
    } catch (readErr) {
      console.error('Error reading scanned image, trying fetch fallback:', readErr);
      try {
        const webPath = Capacitor.convertFileSrc(imgUri);
        const response = await fetch(webPath);
        const blob = await response.blob();
        return await this.convertBlobToBase64(blob) as string;
      } catch (fetchErr) {
        console.error('Fetch fallback failed:', fetchErr);
        return '';
      }
    }
  }



  async saveMultipleImagesDirectly(imagesToSave: string[]) {
    this.saving = true;
    try {
      await this.metodosUi.showLoading('Guardando imágenes...');
      for (const base64 of imagesToSave) {
        const json = this.metodosGenService.setModeloGeneral(
          'genModel',
          'INSERT',
          '0',
          String(this.trabajoId),
          this.gastoActual.fecha || this.getTodayLocalString(),
          this.gastoActual.lugar || '',
          String(this.gastoActual.monto || 0),
          this.gastoActual.descripcion || 'Imagen cargada en lote',
          this.gastoActual.tipo || '',
          base64,
          '', '', '', '', '', '', ''
        );
        
        await firstValueFrom(this.javapiService.saveGasto(json));
      }
      await this.metodosUi.hideLoading();
      this.metodosUi.showToast('Imágenes guardadas correctamente', 'success');
      this.modalCtrl.dismiss({ success: true });
    } catch (e) {
      await this.metodosUi.hideLoading();
      console.error(e);
      this.metodosUi.showToast('Error al guardar imágenes', 'danger');
    } finally {
      this.saving = false;
    }
  }

  convertBlobToBase64(blob: Blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(blob);
    });
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        let res = reader.result as string;
        this.archivosNuevosBase64 = [res];
        this.archivoName = file.name;

        if (file.type === 'application/pdf') {
          this.isPdf = true;
          this.archivosPreview = [];
        } else {
          this.isPdf = false;
          this.archivosPreview = [res];
        }
        this.archivoEliminado = false;
      };
      reader.readAsDataURL(file);
    }
  }

  removeFile(event: Event) {
    event.stopPropagation();
    this.archivosNuevosBase64 = [];
    this.archivosPreview = [];
    this.archivoName = '';
    this.isPdf = false;
    this.archivoEliminado = true;
    if (this.fileInput && this.fileInput.nativeElement) {
      this.fileInput.nativeElement.value = '';
    }
  }

  async saveGasto() {
    this.updateTipoString();
    const hasFile = (this.archivosNuevosBase64.length > 0 || (this.gastoActual.archivos && !this.archivoEliminado));

    // El lugar siempre es obligatorio para saber dónde se hizo la compra
    const lugarExists = this.comerciosList.some(c => (c.nombre || '').toLowerCase().trim() === (this.gastoActual.lugar || '').toLowerCase().trim());
    if (!this.gastoActual.lugar || !lugarExists) {
      this.metodosUi.showToast('Debe seleccionar un Lugar de la lista (obligatorio)', 'warning');
      return;
    }

    // Si NO hay archivo, validamos el resto de campos obligatorios
    if (!hasFile) {
      if (!this.gastoActual.monto || !this.gastoActual.descripcion) {
        this.metodosUi.showToast('Monto y Descripción son requeridos si no hay adjunto', 'warning');
        return;
      }

      if (this.selectedCategorias.length === 0) {
        this.metodosUi.showToast('Debe seleccionar al menos una Categoría o adjuntar evidencia.', 'warning');
        return;
      }
    }

    this.saving = true;
    try {
      if (this.archivosNuevosBase64.length > 0) {
        // Si estamos actualizando un gasto que ya tenía archivos adjuntos, limpiamos los anteriores en backend para no duplicar
        if (this.gastoActual.id > 0 && this.gastoActual.archivos) {
          const deleteOldFilesJson = this.metodosGenService.setModeloGeneral(
            'genModel',
            'UPDATE',
            String(this.gastoActual.id),
            String(this.trabajoId),
            this.gastoActual.fecha,
            this.gastoActual.lugar,
            String(this.gastoActual.monto),
            this.gastoActual.descripcion,
            this.gastoActual.tipo,
            'DELETE_FILE',
            '', '', '', '', '', '', ''
          );
          await firstValueFrom(this.javapiService.saveGasto(deleteOldFilesJson));
          this.gastoActual.archivos = '';
        }

        let first = true;
        for (const base64 of this.archivosNuevosBase64) {
          const json = this.metodosGenService.setModeloGeneral(
            'genModel',
            this.gastoActual.id > 0 ? 'UPDATE' : 'INSERT',
            String(this.gastoActual.id),
            String(this.trabajoId),
            this.gastoActual.fecha,
            this.gastoActual.lugar,
            String(this.gastoActual.monto),
            this.gastoActual.descripcion,
            this.gastoActual.tipo,
            base64,
            '', '', '', '', '', '', ''
          );
          
          const result = await firstValueFrom(this.javapiService.saveGasto(json));
          if (first) {
             if (result && result.id) {
               this.gastoActual.id = result.id;
             }
             first = false;
          }
        }
      } else {
        const json = this.metodosGenService.setModeloGeneral(
          'genModel',
          this.gastoActual.id > 0 ? 'UPDATE' : 'INSERT',
          String(this.gastoActual.id),
          String(this.trabajoId),
          this.gastoActual.fecha,
          this.gastoActual.lugar,
          String(this.gastoActual.monto),
          this.gastoActual.descripcion,
          this.gastoActual.tipo,
          this.archivoEliminado ? 'DELETE_FILE' : '',
          '', '', '', '', '', '', ''
        );
        await firstValueFrom(this.javapiService.saveGasto(json));
      }

      this.metodosUi.showToast('Gasto guardado correctamente', 'success');
      this.modalCtrl.dismiss({ success: true });
    } catch (e) {
      console.error(e);
      this.metodosUi.showToast('Error al guardar', 'danger');
    } finally {
      this.saving = false;
    }
  }

  async delete() {
    const confirm = await this.metodosUi.showConfirmation('Confirmar Eliminación', `¿Seguro que desea eliminar el gasto de $${this.gastoActual.monto}?`, 'Eliminar', true);
    if (confirm) {
        this.modalCtrl.dismiss({ delete: true });
    }
  }

  async llenarConIA() {
    let base64 = this.archivosPreview[0] || (this.archivosNuevosBase64.length > 0 ? this.archivosNuevosBase64[0] : null);
    if (!base64) {
      this.metodosUi.showToast('Debe cargar una imagen primero', 'warning');
      return;
    }

    this.loadingAI = true;
    try {
      // Redimensionar y comprimir la imagen para evitar payloads enormes y time outs
      base64 = await this.resizeBase64Image(base64, 1200, 1200);

      // 1. Cargar configuración de base de datos
      const paramRes = await firstValueFrom(this.javapiService.getJsonParam('CONFIG_IA_ANALIZAR_FACTURA'));
      let model = undefined;
      let temperature = undefined;
      let systemInstruction = undefined;
      let prompt = undefined;
      let freeAttempts = 2;
      let payAttempts = 1;
      let forcePay = false;

      if (paramRes && paramRes.pa_json) {
        try {
          const config = typeof paramRes.pa_json === 'string' ? JSON.parse(paramRes.pa_json) : paramRes.pa_json;
          model = config.model;
          temperature = config.temperature;
          systemInstruction = config.system_instruction;
          prompt = config.prompt_template;
          
          if (config.free_attempts !== undefined) freeAttempts = Number(config.free_attempts);
          if (config.pay_attempts !== undefined) payAttempts = Number(config.pay_attempts);
          if (config.force_pay !== undefined) forcePay = !!config.force_pay;
        } catch (parseErr) {
          console.error('Error parseando CONFIG_IA_ANALIZAR_FACTURA', parseErr);
        }
      }

      // Reemplazar tokens de fecha actuales para darle contexto de tiempo real a la IA
      const hoyStr = this.getTodayLocalString(); // "YYYY-MM-DD"
      const anoStr = String(new Date().getFullYear()); // "YYYY"
      if (prompt) {
        prompt = prompt.replace(/{FECHA_HOY}/g, hoyStr).replace(/{ANO_HOY}/g, anoStr);
      }
      if (systemInstruction) {
        systemInstruction = systemInstruction.replace(/{FECHA_HOY}/g, hoyStr).replace(/{ANO_HOY}/g, anoStr);
      }

      // 2. Generar lista de intentos (true = usar clave de pago, false = clave gratuita)
      const attemptsList: boolean[] = [];
      if (forcePay) {
        for (let i = 0; i < payAttempts; i++) {
          attemptsList.push(true);
        }
      } else {
        for (let i = 0; i < freeAttempts; i++) {
          attemptsList.push(false);
        }
        for (let i = 0; i < payAttempts; i++) {
          attemptsList.push(true);
        }
      }
      if (attemptsList.length === 0) {
        attemptsList.push(false);
      }

      let res = null;
      let success = false;
      const totalAttempts = attemptsList.length;

      for (let idx = 0; idx < totalAttempts; idx++) {
        const usePayKey = attemptsList[idx];
        const attempt = idx + 1;
        if (usePayKey) {
          this.aiAttemptStatus = `Analizando factura (Intento ${attempt}/${totalAttempts} - Plan de pago)...`;
        } else {
          this.aiAttemptStatus = `Analizando factura (Intento ${attempt}/${totalAttempts})...`;
        }

        try {
          res = await firstValueFrom(
            this.javapiService.analizarFactura(base64, prompt, systemInstruction, model, temperature, usePayKey, attempt, totalAttempts)
          );
          if (res && res.result) {
            success = true;
            break; // Salida del bucle si fue exitoso
          } else {
            console.warn(`Intento ${attempt}/${totalAttempts} fallido con respuesta del backend:`, res);
          }
        } catch (attemptErr) {
          console.error(`Error en intento ${attempt}/${totalAttempts}:`, attemptErr);
        }

        // Esperar 1 segundo antes del siguiente intento
        if (attempt < totalAttempts) {
          await new Promise(r => setTimeout(r, 1000));
        }
      }

      if (!success) {
        throw new Error(res && res.error ? res.error : `No se pudo obtener una respuesta válida de la IA tras ${totalAttempts} intentos.`);
      }

      if (res && (res.data || res.result)) {
        const data = res.data || this.metodosGenService.parsearJsonIa(res.result);

        if (!data || (data && !data.monto && !data.fecha && !data.descripcion && !data.lugar)) {
          throw new Error('La respuesta de la IA no contiene datos legibles.');
        }

        // Llenar formulario (con soporte para llaves alternativas)
        const extractedFecha = data.fecha || data.date || data.fecha_factura;
        if (extractedFecha) this.gastoActual.fecha = extractedFecha;

        const extractedMonto = data.monto || data.total || data.monto_total || data.amount;
        if (extractedMonto) this.gastoActual.monto = extractedMonto;

        const extractedDesc = data.descripcion || data.description || data.items || data.detalle;
        if (extractedDesc) {
          this.gastoActual.descripcion = typeof extractedDesc === 'string' ? extractedDesc : JSON.stringify(extractedDesc, null, 2);
        }

        // Tipo de categoría especial 'IA': agregamos a la lista seleccionada
        if (!this.selectedCategorias.includes('IA')) {
          this.selectedCategorias.push('IA');
        }
        this.updateTipoString();

        // Validar e insertar categoría 'IA' de forma persistente si no existe
        const categoriaExists = this.categoriasList.some(c => (c.nombre || c || '').toLowerCase().trim() === 'ia');
        if (!categoriaExists) {
          const nextCatId = this.categoriasList.length > 0 ? 
            (Math.max(...this.categoriasList.map(c => {
              const idVal = c.id || c.dt1 || 0;
              return isNaN(Number(idVal)) ? 0 : Number(idVal);
            })) + 1).toString() : '1';
          
          const nuevaCategoria = { id: nextCatId, nombre: 'IA' };
          this.categoriasList.push(nuevaCategoria);
          await firstValueFrom(this.javapiService.saveJsonParam('fe_lista_categorias_gastos', JSON.stringify(this.categoriasList)));
          await this.loadCategorias();
        }

        // Validar e insertar comercio/lugar de forma persistente si no existe
        const extractedLugar = data.lugar || data.comercio || data.vendor || data.place || data.establishment;
        if (extractedLugar) {
          const parsedLugar = String(extractedLugar).trim();
          const commerceExists = this.comerciosList.some(c => (c.nombre || c || '').toLowerCase().trim() === parsedLugar.toLowerCase());
          if (!commerceExists) {
            const nextId = this.comerciosList.length > 0 ? 
              (Math.max(...this.comerciosList.map(c => {
                const idVal = c.id || c.dt1 || 0;
                return isNaN(Number(idVal)) ? 0 : Number(idVal);
              })) + 1).toString() : '1';
            
            const nuevoComercio = { id: nextId, nombre: parsedLugar };
            this.comerciosList.push(nuevoComercio);
            await firstValueFrom(this.javapiService.saveJsonParam('fe_lista_comercios', JSON.stringify(this.comerciosList)));
            await this.loadComercios();
          }
          this.gastoActual.lugar = parsedLugar;
        }

        this.metodosUi.showToast('Formulario completado con IA exitosamente', 'success');
      } else {
        throw new Error('Respuesta inválida de la IA');
      }
    } catch (e: any) {
      console.error('Error al analizar factura con IA:', e);
      this.metodosUi.showToast(e?.message || 'Error al procesar con IA', 'danger');
    } finally {
      this.loadingAI = false;
      this.aiAttemptStatus = 'Llenar formulario con IA';
    }
  }

  resizeBase64Image(base64Str: string, maxWidth = 1200, maxHeight = 1200): Promise<string> {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = base64Str;
      img.onload = () => {
        let width = img.width;
        let height = img.height;

        if (width > height) {
          if (width > maxWidth) {
            height = Math.round((height * maxWidth) / width);
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width = Math.round((width * maxHeight) / height);
            height = maxHeight;
          }
        }

        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d');
        if (ctx) {
          ctx.drawImage(img, 0, 0, width, height);
          resolve(canvas.toDataURL('image/jpeg', 0.7));
        } else {
          resolve(base64Str);
        }
      };
      img.onerror = () => {
        resolve(base64Str);
      };
    });
  }

  close() {
    this.modalCtrl.dismiss();
  }

  private getTodayLocalString(): string {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  }
}
